import { TableId } from '../../lib/table-pipeline/brands';
import {
  FilterOpts,
  SortOpts,
  ViewOpts
} from '../../lib/table-pipeline/contracts';

export class SetFilter {
  public static readonly type = '[TablePipeline] Set filter';
  constructor(
    public readonly tableId: TableId,
    public readonly filter: FilterOpts | undefined
  ) {}
}

export class SetSort {
  public static readonly type = '[TablePipeline] Set sort';
  constructor(
    public readonly tableId: TableId,
    public readonly sort: SortOpts | undefined
  ) {}
}

export class SetView {
  public static readonly type = '[TablePipeline] Set view';
  constructor(
    public readonly tableId: TableId,
    public readonly view: ViewOpts | undefined
  ) {}
}

export class Reset {
  public static readonly type = '[TablePipeline] Reset';
  constructor(public readonly tableId: TableId) {}
}
